const INITIAL_STATE = {
    apps: {},
    isLoading: false,
}

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
    default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/AppReducer.js